<div class="row mb-2">
  <div class="col">
    <h3 class="with-manual-link">
      <span i18n="@@supervisor">Supervisor</span>
      <app-manual-link
        href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Insights/Supervisor"></app-manual-link>
    </h3>
  </div>
  <div class="col-auto">
    <p-button
      severity="secondary"
      [outlined]="true"
      size="small"
      icon="ri ri-more-2-fill"
      i18n-label="@@supervisor-functions"
      label="Supervisor-Funktionen"
      [routerLink]="['/bot-admin', this.supervisorService.getSelectedBot(), 'supervisor', 'functions']"
    ></p-button>
  </div>
</div>
<app-form-for-boolean
  [label]="this.supervisorActive"
  [(value)]="this.rss.botConfig.supervisorEnabled"
  (valueChange)="this.rss.saveBotConfigField('supervisorEnabled')"
>

  @if (this.rss.botConfig.supervisorEnabled) {
  <app-hint i18n="@@supervisor-enabled-hint">
    Der Supervisor kann die Konversationen überwachen und bei Bedarf eingreifen.
  </app-hint>
  }
  @if (!this.rss.botConfig.supervisorEnabled) {
  <app-hint i18n="@@supervisor-disabled-hint">
    Der Supervisor kann <b>nicht</b> die Konversationen überwachen und bei Bedarf eingreifen.
  </app-hint>
  }
</app-form-for-boolean>
<div class="mb-3"></div>
<div class="mb-3 d-flex align-items-center gap-2">
  <p-inputgroup class="flex-grow-1">
    <p-inputgroup-addon>
      <i class="ri-filter-3-line"></i>
    </p-inputgroup-addon>
    <input
      pInputText
      type="text"
      placeholder="Suche nach Nutzer, Datum oder Inhalt"
      i18n-placeholder="@@supervisor-search-placeholder"
      [(ngModel)]="this.chatSearchInput"
      (ngModelChange)="this.supervisorService.filterThreads($event)"
      fluid
    >
    <p-button
      [outlined]="!this.filterOnlineOnly"
      [severity]="this.filterOnlineOnly ? 'primary' : 'secondary'"
      icon="ri ri-circle-fill"
      i18n-label="@@online"
      label="Online"
      i18n-pTooltip="@@supervisor-filter-online-tooltip"
      pTooltip="Nur aktive Chats anzeigen"
      (onClick)="this.filterOnlineOnly = !this.filterOnlineOnly"
    />
    <p-button
      [outlined]="!this.filterWithNotifications"
      [severity]="this.filterWithNotifications ? 'warn' : 'secondary'"
      icon="ri ri-megaphone-fill"
      i18n-label="@@notifications"
      label="Meldungen"
      i18n-pTooltip="@@supervisor-filter-notifications-tooltip"
      pTooltip="Chats mit offenen Meldungen anzeigen"
      (onClick)="this.filterWithNotifications = !this.filterWithNotifications"
    />


    <p-inputNumber
      style="width: 15rem; flex: 0 0 auto"
      [inputStyleClass]="this.filterMinMessages > 0 ? 'bg-primary-50' : ''"
      [(ngModel)]="this.filterMinMessages"
      [min]="0"
      [step]="1"
      prefix="Mindestens "
      suffix=" Nachrichten"
    />
  </p-inputgroup>
  <p-button
    severity="secondary"
    [outlined]="true"
    icon="ri ri-filter-off-line"
    i18n-pTooltip="@@supervisor-filter-reset-tooltip"
    pTooltip="Alle Filter zurücksetzen"
    [disabled]="!this.hasActiveFilters"
    (onClick)="this.resetFilters()"
  />
</div>
<div
  class="row mx-n5 py-2"
  style="background-color: #fff; border-top: 1px solid var(--p-content-border-color); border-bottom: 1px solid var(--p-content-border-color); position: relative; z-index: 1;"
>
  <div class="col-3 d-flex align-items-center gap-2">
    <p-checkbox
      inputId="selectallcheckbox"
      [binary]="true"
      [ngModel]="this.threadBroadcastService.allThreadSelected()"
      (onChange)="this.selectAllThreads()"
    ></p-checkbox>
    <div class="d-flex flex-column gap-1">
      <p-tag
        [severity]="this.supervisorService.activeThreadsCount() === 0 ? 'secondary' : 'info'"
        value="{{this.supervisorService.activeThreadsCount() }} Online"
      ></p-tag>
      <p-tag
        severity="secondary"
        icon="ri ri-chat-unread-line"
        value="{{this.supervisorService.historyItems.length}} - &#8960; {{this.supervisorService.getStatsForBot().arith}} ms"
      ></p-tag>
    </div>
  </div>

  <div class="col d-flex align-items-center gap-3 ps-0">
    @let myThread = this.supervisorService.selectedThread;
    @let hItem = myThread ? myThread[0] : undefined;
    @if(hItem && myThread) {
    @let userName = this.supervisorService.getUserIdToName(hItem.context.user);
    <div class="d-flex align-items-center gap-2">
      <span
        style="display:inline-block;width:8px;height:8px;border-radius:50%;flex-shrink:0"
        [style.background-color]="this.supervisorService.isThreadActive(hItem.threadId) ? 'var(--p-green-500,#22c55e)' : 'var(--p-surface-300,#d1d5db)'"
      ></span>
      <i
        class="ri-user-2-fill"
        [style.color]="this.getThreadColor(hItem.context.user)"
      ></i>
      <span class="fw-semibold">{{ userName || hItem.context.user.slice(0, 8) }}</span>
    </div>
    <small class="text-muted ms-2">
      <i class="ri-chat-unread-line"></i>
      {{myThread.length}} - &#8960;
      {{this.supervisorService.getStatsForThread(hItem.threadId).arith}} ms
    </small>
    @for (keyval of this.supervisorService.keyVals; track keyval; let i = $index) {
    <div>
      <small class="keyval-key">{{keyval.key}}: </small>
      <small>{{keyval.value}}</small>
    </div>
    }
    }
  </div>
</div>
<div
  #wrapper
  class="row mx-n5"
>
  <div
    #vp
    class="col-3 p-0 m-0 pe-0 border-end border-bottom overflow-y-auto"
    style="overflow-x: hidden"
    [ngStyle]="{'height': 'calc(100vh - 3rem - ' + headOffset +'px)'}"
  >
    <app-supervisor-threads
      [viewPort]="{height: vp.clientHeight, width: vp.clientWidth}"
      [filterOnlineOnly]="this.filterOnlineOnly"
      [filterWithNotifications]="this.filterWithNotifications"
      [filterMinMessages]="this.filterMinMessages"
    />
  </div>
  <div
    class="col p-0 d-flex flex-column"
    style="min-width: 0; overflow: hidden"
    [ngStyle]="{'height': 'calc(100vh - 3rem - ' + headOffset +'px)'}"
  >
    <div
      class="flex-grow-1 overflow-y-auto"
      style="overflow-x: hidden"
    >

      @if (this.threadBroadcastService.selectedThreadsSet.size === 0 && this.supervisorService.selectedThread) {
      <app-supervisor-chat></app-supervisor-chat>
      }

      @if (this.threadBroadcastService.selectedThreadsSet.size === 0 && !this.supervisorService.selectedThread) {
      <div class="d-flex flex-column align-items-center justify-content-center h-100 text-muted gap-2">
        <i
          class="ri-chat-2-line"
          style="font-size: 2.5rem"
        ></i>
        <span i18n="@@supervisor-no-chat-selected">Wähle einen Chat aus der Liste aus.</span>
      </div>
      }

      @if (this.threadBroadcastService.selectedThreadsSet.size > 0) {
      <div class="p-4">
        <div class="d-flex align-items-center gap-2 mb-1">
          <i class="ri-checkbox-circle-fill text-primary"></i>
          <h5 class="mb-0">
            <span i18n="@@selection">Auswahl:</span>
            {{this.threadBroadcastService.selectedThreadsSet.size}}
          </h5>
        </div>
        @let activechats = this.threadBroadcastService.selectedThreadsSet.size -
        this.threadBroadcastService.inactiveThreadCount();
        <small
          class="text-muted"
          i18n="@@thereof-online"
        >Davon online: {{activechats}}</small>
        <p-message
          class="d-block mt-3"
          severity="info"
          i18n="@@broadcast-hint"
        >Nachrichten und Supervisor-Funktionen unten senden — sie werden parallel an alle ausgewählten Chats
          übertragen.</p-message>
        <div class="d-flex gap-2 mt-3">
          <p-button
            icon="ri ri-file-download-line"
            severity="secondary"
            [outlined]="true"
            size="small"
            (click)="this.downloadSelectedChatsAsZip()"
            i18n-label="@@download-as-zip"
            label="Als ZIP herunterladen"
          />
        </div>
      </div>
      }

    </div>
    @let canSendPrompt = this.isSelectedChatActive() || (this.supervisorService.selectedThread === undefined &&
    !this.threadBroadcastService.noSelectedThreadActive());
    @let canTriggerFunction = canSendPrompt;

    @if (this.supervisorService.selectedThread || this.threadBroadcastService.selectedThreadsSet.size > 0) {
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-top border-bottom">
      <app-supervisor-function-exec [disabled]="!canTriggerFunction" />
      <div class="flex-grow-1">
        <app-supervisor-prompt-input [disabled]="!canSendPrompt" />
      </div>
    </div>
    }
  </div>
</div>